import { TranslationService } from '@rocheglobal/component-library-dot-com/src/services/translation';
import React, { useEffect, useState } from 'react';
import { StringService } from '@rocheglobal/component-library-dot-com/src/services/string';
import { DatalayerItem, TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';
import { HistoryService } from '@rocheglobal/component-library-dot-com/src/services/history';
import { NavigationService } from '../../services';
import { NavigationLink, NavigationProps } from '../../services/navigation/types';
import { AdobeTracking } from '../../tracking';

interface NavigationMobileState {
  translations?: {
    explore: string;
  };
}

const defaultTracking: DatalayerItem = {
  event: 'navigation_click',
  component_name: 'roche-navigation',
};

const trackLinkClick = (event): void => {
  const targetLink = event.target?.getAttribute('href')
    ? event.target?.getAttribute('href')
    : event.target?.parentElement?.getAttribute('href');

  const targetText = event.target?.innerText
    ? event.target?.innerText
    : event.target?.parentElement?.innerText;

  TrackingService.push({
    ...defaultTracking,
    additionalParameters: {
      current_location: HistoryService.getActiveUrl().pathname,
      link_text: targetText,
    },
    value: targetLink,
  });

  const updatedData = {
    url: targetLink,
    innerText: targetText,
    position: 'Navigation',
    type: 'Link',
    socialMedia: '',
    socialInteraction: '',
  };

  AdobeTracking(updatedData, 'defaultLinkClick');
};
/* Must be defined as a function, otherwise thisArg won't be correctly bound */
function renderNavigationItem(
  {
    nested_links: nested, text, url, addRightArrow,
  }: NavigationLink,
  index,
): JSX.Element {
  // ignore separator
  if (!url) {
    return null;
  }

  const listClassName = NavigationService.isCurrentPage(url)
    ? NavigationService.currentPageCssClass
    : '';

  // Top level
  if (nested?.length > 0) {
    const { explore } = (this as NavigationMobileState).translations || {};
    return (
      <li key={index} className={listClassName}>
        <span>
          {text}
          <roche-icon icon="chevron-down" height="24px"></roche-icon>
        </span>
        <ul>
          <li>
            <a href={NavigationService.getParsedNavigationLink(url)} onClick={trackLinkClick}>
              {StringService.capitalize(explore)}
              <roche-icon icon="arrow-right" height="24px"></roche-icon>
            </a>
          </li>
          {nested.map(renderNavigationItem)}
        </ul>
      </li>
    );
  }

  return (
    <li key={index} className={listClassName}>
      <a href={NavigationService.getParsedNavigationLink(url)} onClick={trackLinkClick}>
        {text}
        {addRightArrow && <roche-icon icon="arrow-right" height="24px"></roche-icon>}
      </a>
    </li>
  );
}

export const NavigationMobile = (
  { tree = [], worldWideLink }: NavigationProps,
): JSX.Element => {
  const [state, setState] = useState<NavigationMobileState>({});
  useEffect(() => {
    const getTranslations = async (): Promise<void> => {
      const newState: NavigationMobileState = {
        translations: {
          explore: await TranslationService.translate('explore'),
        },
      };

      setState(newState);
    };
    getTranslations();
  }, []);

  if (!state.translations?.explore) {
    return null;
  }

  return (
    <roche-navigation-mobile
      world-wide-link={NavigationService.getParsedLink(worldWideLink) !== '' ? NavigationService.getParsedNavigationLink(worldWideLink) : null}>
      {tree
        .map((list, index) => (
          <ul key={index}>
            {list.map(renderNavigationItem, state)}
          </ul>
        ))}
      <roche-language-switch layout="inline-list"></roche-language-switch>
    </roche-navigation-mobile>
  );
};
